export class RequestError extends Error {
    static formatMessage(request: { method?: string; url: string }, response: Response, data?: unknown) {
        let message = `${request.method ?? 'GET'} ${request.url} failed with status ${response.status}`;

        if (response.headers.get('content-type')?.includes('text/html')) {
            return message;
        }

        if (typeof data === 'string') {
            message += `:\n${data}`;
        }

        if (typeof data === 'object' && data !== null) {
            const details = Object.entries(data)
                .map(([key, value]) => `${key}: ${typeof value === 'object' && value !== null ? JSON.stringify(value) : value}`)
                .join('\n');
            message += `:\n\n${details}\n`;
        }

        return message;
    }

    override name = 'RequestError';

    constructor(
        public readonly request: { method?: string; url: string },
        public readonly response: Response,
        public readonly data?: unknown,
    ) {
        super(RequestError.formatMessage(request, response, data));
    }
}
